/**
 * Column header for ScaleDropModal 3-column layout.
 * Matches the PrepareNewDropsForm SectionHeader style.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { ElementType, FC, ReactNode } from 'react';

interface ColumnHeaderProps {
  icon: ElementType<{ className?: string }>;
  title: string;
  subtitle?: string;
  badge?: ReactNode;
}

export const ColumnHeader: FC<ColumnHeaderProps> = ({ icon: Icon, title, subtitle, badge }) => (
  <div className="flex shrink-0 items-start gap-2 border-b border-border/40 bg-muted/30 px-4 py-3">
    <Icon className="mt-0.5 h-4 w-4 text-primary" />
    <div className="flex-1">
      <h3 className="flex items-center gap-2 text-sm font-semibold text-foreground">
        {title}
        {badge}
      </h3>
      {subtitle && <p className="text-xs text-muted-foreground">{subtitle}</p>}
    </div>
  </div>
);
